import type { Promotion } from '~/types/promotion/Promotion'

export const promotions: Promotion[] = JSON.parse(import.meta.env.VITE_PROMOTIONS as string)
